import * as Main from '/app/js/panel/Main.js';
import * as UIUtil from "../util/UI.js";
import * as Header from "/app/js/panel/Header.js";
import * as Footer from "/app/js/panel/Footer.js";
import * as Simple from "/app/js/panel/Simple.js";
import * as Contact from "/app/js/panel/Contact.js";
import * as Information from "/app/js/common/Information.js";
import * as Gallery from "../panel/Gallery.js";
import * as Notice from "/app/js/notice/panel/Notice.js";
// import * as Client from "/app/js/client/panel/Client.js";
import * as News from "/app/js/news/panel/News.js";
import * as Resources from "/app/js/resources/panel/Resources.js";
import * as ApplicationFields from "/app/js/applicationFields/panel/ApplicationFields.js";

const menu = {
    main:{
        Main:{
            ACTIVE: true,
            KEY_MENU: true,
            CLASS: Main,
        },
        Information:{
            ACTIVE: false,
            CLASS: Information,
        },
    },
    aboutus:{
        Greeting:{
            ACTIVE: false,
            KEY_MENU: true
        },
        Vision:{
            ACTIVE: false
        },
        History:{
            ACTIVE: false
        },
        Ci:{
            ACTIVE: false
        },
        Contact:{
            ACTIVE: false,
            CLASS: Contact,
        },
    },
    esg: {
        Esg:{
            ACTIVE: false,
            KEY_MENU: true
        },
        Environmental:{
            ACTIVE: false
        },
        HumanRights:{
            ACTIVE: false
        },
        Ethical:{
            ACTIVE: false
        },
        Safety:{
            ACTIVE: false
        },
    },
    business: {
        SiSm:{
            ACTIVE: false,
            KEY_MENU: true
        },
        Database:{
            ACTIVE: false
        },
        RndConsulting:{
            ACTIVE: false
        },
        Overseas:{
            ACTIVE: false
        },
        ApplicationFields:{
            ACTIVE: false,
            CLASS: ApplicationFields,
        }
    },
    product: {
        Engine:{
            ACTIVE: false,
            KEY_MENU: true
        },
        Lbs:{
            ACTIVE: false
        },
        Utilization:{
            ACTIVE: false
        },
        Equipment:{
            ACTIVE: false
        },
    },
    client: {
        DomesticClients:{
            ACTIVE: false,
            KEY_MENU: true,
            // CLASS: Client
        },
        OverseasClients:{
            ACTIVE: false
        },
    },
    prcenter: {
        Notice:{
            ACTIVE: false,
            KEY_MENU: true,
            CLASS: Notice,
        },
        News:{
            ACTIVE: false,
            CLASS: News,
        },
        Resources:{
            ACTIVE: false,
            CLASS: Resources,
        },
        AwardsCertifications:{
            ACTIVE: false
        },
        Recruitment:{
            ACTIVE: false
        },
        Blog:{
            ACTIVE: false
        },
    },

}

export const openMenu = async function (menuKey, changeLangKey) {
    //menuKey를 통해 getMenuInfo 함수를 통해 해당 메뉴의 정보를 가져온 후
    //해당 메뉴의 ACTIVE를 true로 변경
    //그리고 해당 메뉴가 CLASS가 null이 아니면 해당 클래스의 open 함수를 실행
    //null이면 Simple.open 함수를 실행

    localStorage.setItem('lastMenuKey', menuKey);

    if (!menuKey) menuKey = 'Main';

    // 현재 히스토리 상태 확인`
    const currentState = history.state;
    const hasDetailId = currentState?.newsId || currentState?.noticeId;

    if (location.hash !== `#${menuKey}`) {
        // 상세 페이지에서 다른 메뉴로 이동하는 경우 히스토리 교체
        if (hasDetailId) {
            // 상세 페이지 히스토리를 현재 메뉴로 교체 (뒤로가기 시 상세 페이지로 안 감)
            history.replaceState({ menuKey }, '', `#${menuKey}`);
        } else {
            // 일반적인 메뉴 이동은 히스토리에 추가
            history.pushState({ menuKey }, '', `#${menuKey}`);
        }
    }

    const beforeMenuKey = getActiveMenuKey();

    if(menuKey === 'Main') {
        await UIUtil.clearPage(true);
    }else{
        await UIUtil.clearPage(false);
    }

    await Header.init();

    setActiveMenu(menuKey, beforeMenuKey);

    const menuInfo = getMenuInfo(menuKey);
    if (menuInfo.CLASS) {
        await menuInfo.CLASS.open();
    } else {
        await Simple.open(menuKey);
    }

    await Gallery.init();

    await Footer.init();

}

export const openFooter = async function(menuKey, key) {

    if(menuKey === 'Main') {
        UIUtil.clearPage(true);
    }else{
        UIUtil.clearPage(false);
    }
    await Header.init();

    if(menuKey=="Information"){
        await Information.open(menuKey, key);
    }else{
        // console.log("Error inside Information openFooter()");
    }

    await Footer.init();


}

export const setActiveMenu = function(menuKey, beforeMenuKey) {
    // menuKey === beforeMenuKey이면 같은 객체를 true → false로 덮어써서
    // ACTIVE가 영구적으로 false가 되는 버그가 있어 가드 필요.
    // (예: 같은 페이지에서 lang 토글 시 setActiveMenu('Resources', 'Resources') 호출됨)
    const menuInfo = getMenuInfo(menuKey);
    menuInfo.ACTIVE = true;

    if (menuKey !== beforeMenuKey) {
        const beforeMenuInfo = getMenuInfo(beforeMenuKey);
        beforeMenuInfo.ACTIVE = false;
    }
}

export const getMenuInfo = function (menuKey) {
    //menuKey를 통해 해당 메뉴의 정보를 리턴
    //depth2인 것을 찾아야 함
    let menuInfo = {};
    for (let key in menu) {
        if (menu[key][menuKey]) {
            menuInfo = menu[key][menuKey];
        }
    }
    return menuInfo;
}

export const getParentKey = function (menuKey) {
    //menuKey를 통해 해당 메뉴의 부모 메뉴의 키값을 리턴
    let parentKey = '';
    for (let key in menu) {
        for (let key2 in menu[key]) {
            if (key2 === menuKey) {
                parentKey = key;
            }
        }
    }
    return parentKey;
}

export const getKeyMenuByParent = function (menuKey) {
    //자식 메뉴 중에서 KEY_MENU가 true인 메뉴키값을 리턴
    let childKey = '';
    for (let key in menu) {
        for (let key2 in menu[key]) {
            if (key === menuKey && menu[key][key2].KEY_MENU) {
                childKey = key2;
            }
        }
    }
    return childKey;
}

export const getActiveMenuKey = function () {
    //현재 ACTIVE가 true인 메뉴를 찾아서 키값을 리턴. depth가 최하위인 것만
    let activeMenu = '';
    for (let key in menu) {
        for (let key2 in menu[key]) {
            if (menu[key][key2].ACTIVE) {
                activeMenu = key2;
            }
        }
    }
    return activeMenu;
}